import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'index',
        component: resolve => require(['@/components/Index.vue'], resolve)
    },
        {
            path: '/aboutYH',
            name: 'aboutYH',
            component: resolve => require(['@/components/AboutYH.vue'], resolve)
        },
        {
            path: '/newList',
            name: 'newList',
            component: resolve => require(['@/components/NewList.vue'], resolve)
        },
        {
            path: '/contactUS',
            name: 'contactUS',
            component: resolve => require(['@/components/ContactUS.vue'], resolve)
        },
        {
            path: '/company',
            name: 'company',
            component: resolve => require(['@/components/Company.vue'], resolve)
        },
        {
            path: '/newsDetail/:id',
            name: 'newsDetail',
            component: resolve => require(['@/components/NewsDetail.vue'], resolve)
        }
    ]
})
